module.exports = __webpack_public_path__ + "51e4f9cafb0fcf856e0a863bdbd9cd10.svg";